import React from 'react';
import { Alert, Typography, Grid, Card, CardContent, Box, Chip, Button } from '@mui/material';
import { getImageUrl } from '../../utils/projectViewUtils';

const PendingApprovalSection = ({ project, user, onApproveItem, onRejectItem }) => {
  if (user.role !== 'homeowner' || !project.rooms) return null;

  const allItems = project.rooms.flatMap(room =>
    room.items.map(item => ({ ...item, roomName: room.name, roomId: room.id }))
  );
  const pendingItems = allItems.filter(item => item.status === 'pending_homeowner');

  if (pendingItems.length === 0) return null;

  return (
    <Alert severity="warning" sx={{ mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Pending Your Approval ({pendingItems.length} items)
      </Typography>
      <Typography variant="body2" gutterBottom>
        The contractor has proposed the following items. Please review and approve the prices before they are added to the project.
      </Typography>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {pendingItems.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card sx={{ borderLeft: '4px solid #ff9800' }}>
              {item.image_url && (
                <Box
                  component="img"
                  src={getImageUrl(item.image_url)}
                  alt={item.title}
                  sx={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              )}
              <CardContent>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                  {item.roomName}
                </Typography>
                <Typography variant="h6" gutterBottom>
                  {item.title}
                </Typography>
                <Chip
                  label={item.type}
                  size="small"
                  color={item.type === 'labor' ? 'primary' : item.type === 'materials' ? 'secondary' : 'info'}
                  sx={{ mr: 1, mb: 1 }}
                />
                <Typography variant="h5" color="primary" gutterBottom>
                  ${parseFloat(item.cost).toLocaleString()}
                </Typography>
                <Box display="flex" gap={1} mt={2}>
                  <Button
                    size="small"
                    variant="contained"
                    color="success"
                    onClick={() => onApproveItem(item.id)}
                    fullWidth
                  >
                    Approve Price
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    color="error"
                    onClick={() => onRejectItem(item.id)}
                    fullWidth
                  >
                    Reject
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Alert>
  );
};

export default PendingApprovalSection;
